// @ts-nocheck
import React, { useState } from 'react';
import ActionBar from '../../layout/ActionBar';
import AddUploader from './slideout/AddUploader';
import UploaderList from './components/UploaderList';
import Uploader from './slideout/Uploader';
import SlidingPane from 'react-sliding-pane';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../../util/pageTitle';
import { useAppSelector } from '../../../hooks';

function Uploaders() {
  usePageTitle(['Uploaders', 'Settings']);
  const { t } = useTranslation();
  const [reload, setReload] = useState<Date | undefined>();

  const currentUser = useAppSelector((state) => state.auth);

  const [addSlideoutOpen, setAddSlideoutOpen] = useState(false);
  const handleAddUploader = (e) => {
    e.cancelBubble = true;
    setAddSlideoutOpen(true);
    return false;
  };

  const [editSlideoutOpen, setEditSlideoutOpen] = useState(false);
  const [editSlideoutItem, setEditSlideoutItem] = useState();
  const handleEditUploader = (id) => {
    setEditSlideoutItem(id);
    setEditSlideoutOpen(true);
    return false;
  };

  return (
    <>
      <ActionBar>
        <Button
          className="btn btn-primary"
          onClick={handleAddUploader}
          text={t('Add uploader')}
          testId="add-uploader-button"
        />
      </ActionBar>

      <UploaderList
        reload={reload}
        onEdit={handleEditUploader}
        currentUser={currentUser}
      />

      <SlidingPane
        isOpen={addSlideoutOpen}
        hideHeader={true}
        from="right"
        className="large-side-panel"
        onRequestClose={() => setAddSlideoutOpen(false)}
      >
        <AddUploader
          cancel={() => setAddSlideoutOpen(false)}
          done={(d) => {
            setReload(new Date());
            setAddSlideoutOpen(false);
          }}
        />
      </SlidingPane>

      <SlidingPane
        isOpen={editSlideoutOpen}
        hideHeader={true}
        from="right"
        className="large-side-panel"
        onRequestClose={() => setEditSlideoutOpen(false)}
      >
        <>
          {editSlideoutItem && (
            <Uploader
              done={(d) => {
                setEditSlideoutOpen(false);
                setReload(new Date());
              }}
              cancel={() => setEditSlideoutOpen(false)}
              id={editSlideoutItem}
            />
          )}
        </>
      </SlidingPane>
    </>
  );
}

export default Uploaders;
